module.exports = __webpack_public_path__ + "static/media/portorico.0376a7f7.jpg";